var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRiskRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3693 11.769H4.84624C3.62272 11.769 2.63086 12.7609 2.63086 13.9844M15.3693 11.769V15.0921C15.3693 15.7039 14.8734 16.1998 14.2616 16.1998H4.84624C3.62272 16.1998 2.63086 15.2079 2.63086 13.9844M15.3693 11.769V2.9075C15.3693 2.29574 14.8734 1.7998 14.2616 1.7998H6.23086M2.63086 13.9844V4.01519C2.63086 2.79167 3.62272 1.7998 4.84624 1.7998H6.23086M9.04313 5.12288H12.0809M9.04313 8.44596H12.0809M6.23086 11.6998V1.7998",
    stroke: "#D7DFE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRiskRegister);
export default __webpack_public_path__ + "static/media/IconRiskRegister.47f58fddbbc649f7eeecad849077d404.svg";
export { ForwardRef as ReactComponent };